import React, { useEffect, useState } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import { Select, message } from "antd";
import Instance from "../../AxiosConfig";

const { Option } = Select;

const SurveillanceDonutChart = () => {
  const [data, setData] = useState();
  const [selectedYear, setSelectedYear] = useState(String(new Date().getFullYear()));
  const currentYear = new Date().getFullYear();

  const yearOptions = Array.from(
    { length: currentYear - 1980 + 6 },
    (_, i) => String(1980 + i)
  );

  const handleSurveillanceData = async (year) => {
    // const token = localStorage.getItem("token");
    try {
      const response = await Instance.get(
        `overview/dashboard/certifications/year/${year}`,
        // {
        //   headers: { Authorization: `Bearer ${token}` },
        // }
      );

      if (response.status === 200 || response.status === 201) {
        setData(response.data);
      }
    } catch (error) {
      console.error("Fetch error", error);
      message.error("Failed to load data");
    }
  };

  useEffect(() => {
    handleSurveillanceData(selectedYear);
  }, [selectedYear]);

  const pieData = data
    ? [
        {
          name: "1st Surveillance",
          value: data.firstSurveillanceDue || 0,
          color: "#C084FC",
        },
        {
          name: "2nd Surveillance",
          value: data.secondSurveillanceDue || 0,
          color: "#2563EB",
        },
        {
          name: "Expired Certifications",
          value: data.expiredCertifications || 0,
          color: "#EF4444",
        },
      ]
    : [];

  return (
    <div className="chart-card donut-card">
      <div className="chart-header">
        <h3 className="chart-title">Surveillance</h3>
        <Select
          value={selectedYear}
          onChange={(value) => setSelectedYear(value)}
          style={{
            width: 90,
            backgroundColor: "#F4F5F9",
            color: "#127285",
          }}
        >
          {yearOptions.map((year) => (
            <Option key={year} value={year}>
              {year}
            </Option>
          ))}
        </Select>
      </div>

      <div className="donut-chart" style={{ height: 250 }}>
        {data ? (
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={pieData}
                cx="50%"
                cy="50%"
                innerRadius={65}
                outerRadius={80}
                paddingAngle={2}
                dataKey="value"
              >
                {pieData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
        ) : (
          <p style={{ textAlign: "center", marginTop: "2rem" }}>
            Loading chart...
          </p>
        )}
      </div>

      <div className="donut-legend">
        {pieData.map((item, index) => (
          <div key={index} className="donut-legend-item">
            <div className="legend-left">
              <span
                className="legend-dot"
                style={{ backgroundColor: item.color }}
              ></span>
              <span className="legend-label">{item.name}</span>
            </div>
            <span className="legend-value">
              {item.value.toLocaleString()}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SurveillanceDonutChart;
